import type { Option } from '@comparit/core';
import { Laufzeit } from '../../../interfaces';

export const laufzeitOptions: Option<Laufzeit>[] = [
  { label: '1 Jahr', value: Laufzeit.L1Jahr },
  { label: '3 Jahre', value: Laufzeit.L3Jahre },
  { label: '5 Jahre', value: Laufzeit.L5Jahre },
];
